<template>
  <div
    :style="
      $store.state.ui_options.theme?.name !== 'Blue Purple Gradient' ? { backgroundColor: $store.state.ui_options.theme?.bg_color } : {}
    "
    :class="[
      !$store.state.ui.side_menu_open ? '!w-0' : '!w-[190px] opacity-100',
      {
        'bg-gradient-to-r from-[#2da8d7] to-[#467ddf]': $store.state.ui_options.theme?.name === 'Blue Purple Gradient',
        open: sideMenuOpen,
        closed: !sideMenuOpen
      }
    ]"
    class="side-menu border-l dark:border-dark-divider-border bg-blue-dark dark:bg-dark-box-background relative z-20 h-full pt-2 overflow-hidden whitespace-nowrap w-[215px]">
    <ul class="flex flex-col h-full text-gray-700 dark:text-gray-200">
      <li v-if="$route.name == 'WorkspaceItem'" class="absolute w-full mb-6 ml-3 text-xl text-start bottom-10 -right-3">
        <div class="flex space-x-2 text-white" :class="[{ 'cursor-pointer': currentItem?.name == 'Workspace' }]">
          <ArrowLeft
            v-if="currentItem?.name === 'Workspace'"
            class="w-5 h-5 mt-1 text-white"
            @click="
              $route.query.last_page ? $router.push(`/workspace/edit/${$route.params.wid}?tab=visible_pages`) : $router.push('/workspace')
            " />
          <div
            @click="
              $route.query.last_page ? $router.push(`/workspace/edit/${$route.params.wid}?tab=visible_pages`) : $router.push('/workspace')
            ">
            {{
              currentItem?.name === "Workspace"
                ? $route.query.last_page == "setup"
                  ? $t("Workspace Pages")
                  : $t("Workspaces")
                : $utils.splitCamelCase(currentItem?.name)
            }}
          </div>
        </div>
      </li>

      <li
        v-for="menu in currentItem?.children?.filter(
          (c) => c.is_visible && c.is_activated && c.module?.entry_point == 'parent' && c.name !== 'Multiple Forecasting Objects'
        )"
        :key="menu"
        class="w-[204px] text-center justify-center"
        @click="handleClickTab(menu)"
        @mouseenter="page_hovered = menu.name.split(' ')[0].toLowerCase()"
        @mouseleave="page_hovered = null">
        <button
          class="relative flex items-center justify-center w-full px-3 py-5 pl-5 my-0 text-gray-700 rounded-lg sm:justify-start dark:text-gray-200">
          <component
            :is="menu.module?.icon_name"
            v-if="menu.module?.icon_name"
            :active="activeTab === menu.name.split(' ')[0].toLowerCase()"
            :dark-mode="$store.state.ui.darkMode"
            class="relative z-10 flex-shrink-0 w-6 h-6 mr-4 text-white"
            :color="getIconColor(menu.name.split(' ')[0].toLowerCase())" />

          <div
            v-if="activeTab == menu.name.split(' ')[0].toLowerCase() || page_hovered == menu.name.split(' ')[0].toLowerCase()"
            :style="{ backgroundColor: getTwBgColor(menu.name.split(' ')[0].toLowerCase()) }"
            class="w-[90%] -ml-5 h-12 absolute mt-1 rounded-r-lg z-0" />
          <BlueArcVector
            v-if="activeTab == menu.name.split(' ')[0].toLowerCase() || page_hovered == menu.name.split(' ')[0].toLowerCase()"
            :color="getBgColor(menu.name.split(' ')[0].toLowerCase())"
            class="absolute -left-[1px] top-0" />
          <BlueArcVector2
            v-if="activeTab == menu.name.split(' ')[0].toLowerCase() || page_hovered == menu.name.split(' ')[0].toLowerCase()"
            :color="getBgColor(menu.name.split(' ')[0].toLowerCase())"
            class="absolute left-0 -bottom-[3px]" />
          <p class="relative z-10 flex sm:block text-white">
            {{ menu.module.label || menu.name }}

            <span
              v-if="menu.name == $t('Inbox') && $store.state.data?.emails_summary?.inbox_unread_count"
              class="items-center justify-center p-1 ml-10 rounded-md w-7 h-7 dark:bg-gray-800 sm:right-4 text-white">
              {{ $store.state.data?.emails_summary?.inbox_unread_count }}
            </span>
          </p>
        </button>
      </li>

      <div v-if="currentItem?.name === 'Portfolio'" class="mt-0 overflow-scroll h-full overflow-x-hidden">
        <SideMenuModulePages
          :use-slug-for-static-pages="true"
          :pages="portfolio_pages"
          :shared-pages="$store.state.portfolio.shared_layouts.filter((l) => l.page == 'portfolio')" />
      </div>

      <div v-if="currentItem?.name === 'Dashboard'" class="relative mt-1 overflow-scroll h-full overflow-x-hidden">
        <SideMenuModulePages
          :use-slug-for-static-pages="false"
          :pages="dashboard_pages"
          :shared-pages="$store.state.portfolio.shared_layouts.filter((l) => l.page == 'dashboard')" />
      </div>

      <div v-if="currentItem?.name === 'Homepage'" class="relative mt-1 overflow-scroll h-full overflow-x-hidden">
        <SideMenuModulePages
          :use-slug-for-static-pages="true"
          :pages="homepages"
          :shared-pages="$store.state.portfolio.shared_layouts.filter((l) => l.page == 'homepage')" />
      </div>

      <div v-if="currentItem?.name === 'Prospecting'" class="relative mt-1 overflow-scroll h-full overflow-x-hidden">
        <SideMenuModulePages :use-slug-for-static-pages="true" :pages="prospectingpages" :shared-pages="[]" />
      </div>

      <div v-if="currentItem?.name === 'Customer Journeys'" class="relative mt-1 overflow-hidden overflow-y-scroll h-full flex flex-col">
        <li v-for="object_type in Object.keys(journeysObjects)" :key="object_type" class="justify-center w-full text-center">
          <Disclosure v-slot="{ open }" :default-open="true" as="div">
            <!-- <DisclosureButton :class="['text-white cursor-pointer flex w-full items-center pl-5 px-2 py-5 text-sm rounded-md ']">
              <component :is="getIcon(object_type)" :class="[{ 'text-[#ffffff]': active_object_type === object_type }, 'text-[#ffffff]']" :color="`${active_object_type === object_type ? '#ffffff' : '#ffffff'}`" class="flex-shrink-0 w-6 h-6 mr-3" aria-hidden="true" />
              <span class="flex-1 text-left capitalize"> {{ object_type }} </span>
              <ChevronDown :class="[{ '-rotate-90': open }]" class="relative w-5 h-5 text-xs transition-transform duration-200 ease-in-out right-10" />
            </DisclosureButton> -->

            <DisclosureButton class="relative flex items-center !w-full gap-2 px-2 py-5 text-sm text-white rounded-md cursor-pointer">
              <div class="border border-white rounded-md">
                <ChevronDown :class="{ '-rotate-90': !open }" class="w-5 h-5 text-white transition-all duration-500 ease-in-out" />
              </div>
              <component
                :is="getIcon(object_type)"
                :class="[{ 'text-[#ffffff]': active_object_type === object_type }, 'text-[#ffffff]']"
                :color="`${active_object_type === object_type ? '#ffffff' : '#ffffff'}`"
                class="flex-shrink-0 w-6 h-6 mr-0"
                aria-hidden="true" />
              {{ object_type.title() }}
            </DisclosureButton>
            <transition name="fade">
              <div
                :class="[`${object_type}-journey`]"
                :style="{
                  maxHeight: height_of_every_journey_section
                }"
                class="overflow-auto no-scrollbar"
                @scroll="(e) => handleScrollJourneysList(e, object_type)">
                <div
                  v-if="open"
                  :style="{ height: `${62 * journeysObjects[object_type].length}px` }"
                  class="bg-white h-0 transition-all duration-500 ease-in-out delay-500 w-[1px] -mt-5 absolute left-[18px] z-40" />

                <DisclosurePanel
                  v-for="journey in journeysObjects[object_type]"
                  :key="journey.id"
                  :class="[{ 'has-tooltip': journey.name.length > 24 }]"
                  class="relative overflow-visible"
                  @mouseleave="page_hovered = null"
                  @mouseenter="page_hovered = journey.id">
                  <div
                    v-if="journey.id === active_journey || page_hovered == journey.id"
                    :style="{ backgroundColor: getTwBgColor(journey.id) }"
                    class="w-[98%] ml-0 h-12 absolute mt-1 rounded-r-lg z-0" />
                  <BlueArcVector
                    v-if="journey.id === active_journey || page_hovered == journey.id"
                    :color="getBgColor(journey.id)"
                    class="absolute left-[0px] -top-[5px]" />
                  <BlueArcVector2
                    v-if="journey.id === active_journey || page_hovered == journey.id"
                    :color="getBgColor(journey.id)"
                    class="absolute left-[0px] -bottom-[1px]" />
                  <div
                    :class="[
                      journey.id === active_journey ? ' cursor-default' : 'cursor-pointer',
                      'flex w-full pl-5 pr-2 py-5 items-center px-2 text-sm relative z-10',
                      'text-white'
                    ]"
                    @click="changeTab(currentItem, journey)">
                    <span class="bg-white -ml-[7px] w-3 h-3 rounded-full mr-2" /> {{ journey.name.slice(0, 22) }}
                    {{ journey.name.length > 22 ? "..." : "" }}
                  </div>
                  <span
                    class="max-w-[210px] text-start whitespace-normal absolute z-50 tooltip items-center px-2 py-1 rounded-md text-sm bg-light-screen-background dark:bg-dark-screen-background font-medium dark:text-dark-body-text gap-2">
                    {{ journey.name }}</span>
                </DisclosurePanel>
              </div>
            </transition>
            <DisclosurePanel v-if="journeys_should_collapse">
              <div
                v-if="journeys_scroll_data[object_type]?.can_scroll"
                class="absolute w-full -mt-5 bg-gray-50"
                @click="handleClickScroll(object_type)">
                <ChevronDown class="ml-[40%] text-xs w-5 h-5 cursor-pointer animate animate-bounce-down relative bottom-1" />
              </div>
            </DisclosurePanel>
          </Disclosure>
        </li>
        <li class="mt-auto cursor-pointer mb-10 w-full flex justify-center items-center">
          <button
            class="py-2.5 sm rounded-lg focus:outline-none ring-0 ring-offset-0 border-transparent btn primary-btn mx-10"
            @click="$emitter.emit(ALL_EMITTERS.ADD_NEW_JOURNEY)">
            <Plus color="white" class="w-5 h-5 mr-2 text-white" aria-hidden="true" />{{ $t("Create New Journey") }}
          </button>
        </li>
      </div>

      <div v-if="currentItem?.name === 'Forecasting'" class="mt-0 overflow-scroll h-full overflow-x-hidden">
        <SideMenuModulePages
          :custom-page-click-function="handleSelectForecast"
          :use-slug-for-static-pages="false"
          :pages="forecasting_pages"
          :shared-pages="$store.state.portfolio.shared_layouts.filter((l) => l.page == 'forecasting')" />
      </div>

      <div v-if="hasPageSettings()" class="mt-auto cursor-pointer mb-10 w-full flex justify-center items-center">
        <button
          class="py-2.5 sm rounded-lg focus:outline-none ring-0 ring-offset-0 border-transparent btn primary-btn mx-5"
          @click="$emitter.emit(ALL_EMITTERS.OPEN_PAGE_SETTINGS, currentItem)">
          <Plus color="white" class="w-5 h-5 mr-2 text-white" aria-hidden="true" /> {{ $t("Add New Page") }}
        </button>
      </div>
      <!-- <div class="absolute ml-2 cursor-pointer bottom-2" @click="$emitter.emit(ALL_EMITTERS.OPEN_TEAM_CHAT)">
        <div class="text-white">
          <ChatHelp />
        </div>
      </div> -->
    </ul>
  </div>
</template>

<script>
import { Sparkles, UsersRound, UserRound, Building2, ChevronDown, Plus, Star, ArrowLeft } from "lucide-vue-next"
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue"
import ToDosPageIcon from "@/components/shared/icons/workspace-pages-icons/ToDosPageIcon.vue"
import WelcomePageIcon from "@/components/shared/icons/workspace-pages-icons/WelcomePageIcon.vue"
import TextInput from "@/components/shared/TextInput.vue"
import ModuleIcon from "@/components/shared/icons/ModuleIcon.vue"
import { MODULES, PAGE_REFERENCES } from "@/store/constants/references"
import BlueArcVector from "@/components/shared/icons/BlueArcVectorTopLeft.vue"
import BlueArcVector2 from "@/components/shared/icons/BlueArcVectorBottomLeft.vue"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"
import { v4 as uuidv4 } from "uuid"
import SideMenuModulePages from "./SideMenuModulePages.vue"

export default {
  name: "SideMenu",
  components: {
    SideMenuModulePages,
    ArrowLeft,
    ModuleIcon,
    WelcomePageIcon,
    ToDosPageIcon,
    Star,
    Building2,
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    ChevronDown,
    UsersRound,
    UserRound,
    Sparkles,
    Plus,
    TextInput,
    BlueArcVector,
    BlueArcVector2
  },
  inject: ["getPageTabs", "setPageLayout", "deletePageLayout", "isModuleVisible", "isModuleActivated"],

  props: {
    currentItem: {
      type: Object,
      required: false
    },

    changeTab: {
      type: Function,
      required: true
    },
    journeysObjects: {
      type: Object,
      required: true
    },
    sideMenuOpen: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      ALL_EMITTERS,
      page_hovered: null,
      journeys_scroll_data: {},
      screen_height: null,
      journeys_should_collapse: false,
      dashboard_groups: [
        {
          name: "Dashboard Group 1",
          id: 1,
          pages: [
            { name: "CSM Manager Dashboard", id: 1 },
            { name: "Q1 Goal Dashboard", id: 2 },
            { name: "Q2 Winning Dashboard", id: 3 }
          ]
        },
        {
          name: "Managers Group",
          id: 2,
          pages: [
            { name: "Manager Page 1", id: 4 },
            { name: "Manager Page 2", id: 5 },
            { name: "Manager Page 3", id: 6 },
            { name: "Manager Page 4", id: 7 },
            { name: "Manager Page 5", id: 8 }
          ]
        },
        {
          name: "Admin Group",
          id: 3,
          pages: [
            { name: "Admin Page 1", id: 9 },
            { name: "Admin Page 2", id: 10 },
            { name: "Admin Page 3", id: 11 },
            { name: "Admin Page 4", id: 12 }
          ]
        }
      ],
      static_company_profile_pages: [
        { slug: "overview", reference_code: MODULES.COMPANY_PROFILE_OVERVIEW, name: "Overview", is_static: true },
        { slug: "insights", reference_code: MODULES.COMPANY_PROFILE_INSIGHTS, name: "Insights", is_static: true },
        { slug: "map", reference_code: MODULES.COMPANY_PROFILE_COMPANY_MAP, name: "Company Map", is_static: true },
        { slug: "actions", reference_code: MODULES.COMPANY_PROFILE_ACTIONS_INTERACTIONS, name: "Activities", is_static: true },
        { slug: "checklists", reference_code: MODULES.COMPANY_PROFILE_CHECKLISTS, name: "Checklists", is_static: true }
      ],

      prospecting_list: [
        { slug: "find_leads", reference_code: "find_leads", name: "Find Leads", is_static: true, page: "prospecting" },
        { slug: "expansion_lists", reference_code: "expansion_lists", name: "Lists", is_static: true, page: "prospecting" },
        { slug: "suggested_list", reference_code: "suggested_list", name: "Suggested", is_static: true, page: "prospecting" },
        { slug: "growth_matrix", reference_code: "growth_matrix", name: "Growth Matrix", is_static: true, page: "prospecting" }
      ],
      active_group: null,
      company_profile_pages: []
    }
  },

  computed: {
    current_page() {
      if (this.$route?.params?.page) {
        return this.$route?.params?.page
      }
      return "default"
    },
    portfolio_pages() {
      const list_grouped = []
      const list_flat = this.$store.state.portfolio.pages_layout["portfolio"]?.filter((p) => !p.is_hidden && !p.is_deleted)
      list_flat?.forEach((item) => {
        if (!item.group_name) {
          list_grouped.push(item)
        } else {
          const index = list_grouped.findIndex((g) => g?.name == item.group_name)
          if (index == -1) {
            list_grouped.push({ name: item.group_name, pages: [item], is_group: true, id: uuidv4() })
          } else {
            list_grouped[index].pages.push(item)
          }
        }
      })

      return list_grouped
    },
    forecasting_pages() {
      const list_grouped = []
      const list_flat = this.$store.state.portfolio.pages_layout["forecasting"]?.filter((p) => !p.is_hidden && !p.is_deleted)
      list_flat?.forEach((item) => {
        if (!item.group_name) {
          list_grouped.push(item)
        } else {
          const index = list_grouped.findIndex((g) => g?.name == item.group_name)
          if (index == -1) {
            list_grouped.push({ name: item.group_name, pages: [item], is_group: true, id: uuidv4() })
          } else {
            list_grouped[index].pages.push(item)
          }
        }
      })

      return list_grouped
    },
    dashboard_pages() {
      const list_grouped = []
      const list_flat = this.$store.state.portfolio.pages_layout["dashboard"]?.filter((p) => !p.is_hidden && !p.is_deleted)
      list_flat?.forEach((item) => {
        if (!item.group_name) {
          list_grouped.push(item)
        } else {
          const index = list_grouped.findIndex((g) => g?.name == item.group_name)
          if (index == -1) {
            list_grouped.push({ name: item.group_name, pages: [item], is_group: true, id: uuidv4() })
          } else {
            list_grouped[index].pages.push(item)
          }
        }
      })

      return list_grouped
    },

    homepages() {
      const list_grouped = []
      const list_flat = this.$store.state.portfolio.pages_layout["homepage"]
        ?.filter((p) => !p.is_hidden && !p.is_deleted)
        .map((p) => {
          return { ...p, is_static: true }
        })
      list_flat?.forEach((item) => {
        if (!item.group_name) {
          list_grouped.push(item)
        } else {
          const index = list_grouped.findIndex((g) => g?.name == item.group_name)
          if (index == -1) {
            list_grouped.push({ name: item.group_name, pages: [item], is_group: true, id: uuidv4() })
          } else {
            list_grouped[index].pages.push(item)
          }
        }
      })

      return list_grouped
    },

    prospectingpages() {
      let prospecting_list_calc
      if (this.isModuleActivated(MODULES.PROSPECTING)) {
        prospecting_list_calc = this.prospecting_list
      }
      return prospecting_list_calc
    },

    height_of_every_journey_section() {
      if (this.journeys_should_collapse) {
        const height_calc = (this.screen_height * 0.5) / Object.keys(this.journeysObjects).length
        return `${height_calc}px`
      }
      return "100%"
    },

    activeTab() {
      if (this.$route.query.tab) {
        return this.$route.query.tab
      } else {
        if (this.$route.path == "/prospecting") {
          return "prospect"
        }

        if (this.$route.path == "/customer-inbox") {
          return "inbox"
        }
        if (this.$route.path == "/portfolio") {
          return "company"
        }
      }
      return this.$route.query.tab
    },

    active_journey() {
      return this.$route.query.journey
    },
    active_object_type() {
      return this.$route.query.object
    }
  },

  watch: {
    journeysObjects: {
      deep: true,
      handler() {
        const all_journeys = []
        Object.keys(this.journeysObjects).forEach((obj) => {
          let can_scroll = false
          if (this.journeysObjects[obj].length > 3) {
            can_scroll = true
          }
          this.journeys_scroll_data[obj] = { can_scroll }

          this.journeysObjects[obj].forEach((j) => {
            all_journeys.push(j)
          })
        })

        const total_side_menu_items = all_journeys.length + Object.keys(this.journeysObjects).length
        if (total_side_menu_items * 60 > this.screen_height * 0.5) {
          this.journeys_should_collapse = true
        } else {
          this.journeys_should_collapse = false
        }
      }
    }
  },

  deactivated() {
    this.unregister_listeners()
  },
  unmounted() {
    this.unregister_listeners()
  },
  activated() {
    this.page_hovered = null
    this.register_listeners()
    console.debug(this.currentItem)
  },
  created() {
    this.register_listeners()
    if (this.$route.name == "CompanyProfile" || this.$route.name == "ObjectProfile") {
      this.companyProfilePages()
    }
    this.active_group = this.dashboard_groups[0]

    this.screen_height = window.innerHeight
  },
  methods: {
    hasPageSettings() {
      const page_settings_pages = ["Dashboard", "Portfolio", "Forecasting", "Homepage"]
      if (page_settings_pages.includes(this.currentItem?.name)) {
        return true
      }
      return false
    },
    register_listeners() {
      this.$emitter.on(ALL_EMITTERS.PORTFOLIO_UPDATED_IN_SIDE_MENU, () => {
        if (this.$route.name == "CompanyProfile" || this.$route.name == "ObjectProfile") {
          this.companyProfilePages()
        }
      })

      this.$emitter.on(ALL_EMITTERS.PAGES_DELETED_IN_SIDE_MENU, ({ pages_deleted, page_ref }) => {
        if (
          pages_deleted.filter((page_deleted) => page_deleted.id == this.$route.params.page || page_deleted.slug == this.$route.params.page)
            .length
        ) {
          const remaining_pages = this.$store.state.portfolio.pages_layout[page_ref].filter(
            (p) => !pages_deleted.find((page_deleted) => page_deleted.id == p.id)
          )
          if (remaining_pages.length) {
            const path_list = this.$route.path?.split("/")
            path_list.splice(path_list.length - 1, 1, remaining_pages[0].id)
            this.$router.replace(`${path_list.join("/")}/`)
          } else {
            const path_list = this.$route.path?.split("/")
            path_list.splice(path_list.length - 1, 1)
            this.$router.replace(`${path_list.join("/")}/`)
          }
        }
      })
      this.$emitter.on(ALL_EMITTERS.CONFIRM_DELETE_PAGE, (page) => {
        this.deletePageLayout(page).then(() => {
          this.$gtag.event("delete_page_click", {
            event_label: "Delete Page",
            layout: page.layout,
            page: page.page,
            name: page.name
          })
          const desired_property = page.is_static ? "slug" : "id"
          if (this.current_page == page[desired_property]) {
            if (page.is_static) {
              this.$emitter.emit(ALL_EMITTERS.FORCE_INIT_LAYOUT)
            } else {
              if (this.$store.state.portfolio.pages_layout[page.page].length) {
                let use_slug_or_id = null
                this.$store.state.portfolio.pages_layout[page.page][0].is_static ? (use_slug_or_id = "slug") : (use_slug_or_id = "id")
                this.$router.push(`${this.$store.state.portfolio.pages_layout[page.page][0][use_slug_or_id]}`)
              } else {
                this.$router.push(`/dashboard`)
              }
            }
          }
        })
      })
    },
    unregister_listeners() {
      this.$emitter.off(ALL_EMITTERS.PORTFOLIO_UPDATED_IN_SIDE_MENU)
      this.$emitter.off(ALL_EMITTERS.CONFIRM_DELETE_PAGE)
      this.$emitter.off(ALL_EMITTERS.PAGES_DELETED_IN_SIDE_MENU)
    },
    getIconColor(value) {
      if (this.page_hovered == value && this.activeTab != value && this.current_page != value && this.active_journey != value) {
        return "#2DA7D7"
      }
      return "#FFFFFF"
    },
    getTwBgColor(value) {
      if (this.activeTab == value || this.current_page == value || this.active_journey == value) {
        return this.$store.state.ui_options.theme.selected_item_color
      }
      return this.$store.state.ui_options.theme?.selected_item_color
    },
    getBgColor(value) {
      if (this.activeTab == value || this.current_page == value || this.active_journey == value) {
        return this.$store.state.ui_options.theme.selected_item_color
      }
      return this.$store.state.ui_options.theme?.selected_item_color
    },

    companyProfilePages() {
      let pages = this.static_company_profile_pages
        .filter((m) => this.isModuleVisible(m.reference_code))
        .concat(
          this.getPageTabs({ page_reference: PAGE_REFERENCES.COMPANY_PROFILE }).map((el) => {
            return { slug: el.type, is_static: true, name: el.plural_label ? el.plural_label : this.$utils.makePlural(el.label) }
          })
        )
      if (
        this.$store.state.portfolio.pages_layout &&
        this.$store.state.portfolio.pages_layout["company_profile"]?.filter((p) => !p.is_static)
      ) {
        pages = this.$utils.clone(pages.concat(this.$store.state.portfolio.pages_layout["company_profile"]?.filter((p) => !p.is_static)))
      }
      this.company_profile_pages = pages
    },

    handleSelectForecast(forecast_id) {
      if (this.$store.state.data.user_forecasts.find((f) => f.id == forecast_id)) {
        this.$store.dispatch(
          "data/selectForecast",
          this.$store.state.data.user_forecasts.find((f) => f.id == forecast_id)
        )
      }
      this.$router.push(forecast_id)
    },
    getIcon(object_type) {
      if (object_type == "company") {
        return Building2
      } else if (object_type == "opportunity") {
        return Star
      } else if (object_type == "contact") {
        return UserRound
      } else if (object_type == "department") {
        return UsersRound
      } else {
        return Sparkles
      }
    },
    handleScrollJourneysList(e, object_type) {
      // e.target.scrollTop + e.target.offsetHeight == e.target.scrollHeight
      if (e.target.scrollTop + e.target.offsetHeight < e.target.scrollHeight) {
        if (this.journeys_scroll_data[object_type]) {
          this.journeys_scroll_data[object_type]["can_scroll"] = true
        }
      } else {
        if (this.journeys_scroll_data[object_type]) {
          this.journeys_scroll_data[object_type]["can_scroll"] = false
        }
      }
    },

    handleClickScroll(object_type) {
      let content = document.querySelector(`.${object_type}-journey`)
      content.scrollTop += 50
    },
    handleClickTab(tab) {
      this.changeTab(this.currentItem, tab)
    }
  }
}
</script>

<style scoped>
.side-menu {
  /* Base styles */
  transition: transform 0.3s ease-in-out;
  transform: translateX(-285px); /* Default state (closed) */
}

.side-menu.open {
  transform: translateX(0); /* Open state */
}

.side-menu.closed {
  transform: translateX(-285px); /* Closed state */
}
</style>
